import { render, staticRenderFns } from "./SectionRepairs.vue?vue&type=template&id=fab67e66&"
import script from "./SectionRepairs.vue?vue&type=script&lang=js&"
export * from "./SectionRepairs.vue?vue&type=script&lang=js&"
import style0 from "./SectionRepairs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports